import React from "react";
import { Link } from "react-router-dom";
import { Anchor, Compass, Search, ShieldCheck, Newspaper } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const quickLinkConfig = [
  { key: "Weather", fallback: "Weather", href: "/weather", icon: Compass },
  { key: "Marinas", fallback: "Marinas", href: "/marinas", icon: Anchor },
  { key: "safety", fallback: "Safety", href: "/learning-center", icon: ShieldCheck },
];

export default function WireHero({ copy, lang, searchQuery, onSearchChange, articleCount = 0 }) {
  const quickLinks = quickLinkConfig.map((item) => ({
    ...item,
    label: item.key === "safety" ? copy.safety : copy.categoryLabels?.[item.key] || item.fallback,
  }));

  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-border bg-ocean text-white shadow-2xl shadow-ocean/20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(28,167,166,0.45),transparent_32rem),linear-gradient(135deg,rgba(11,37,69,0.98),rgba(19,49,92,0.92))]" />
      <div className="relative grid gap-8 p-6 md:p-10 lg:grid-cols-[1.1fr_0.9fr] lg:p-12">
        <div className="flex flex-col justify-center">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-black uppercase tracking-[0.18em] text-seafoam backdrop-blur">
            <Newspaper className="h-4 w-4" /> {copy.brand}
          </div>
          <h1 className="mt-5 max-w-4xl font-heading text-4xl font-black leading-tight text-white md:text-6xl">{copy.heroTitle}</h1>
          <p className="mt-5 max-w-2xl text-lg leading-8 text-white/82">{copy.heroIntro}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button asChild className="bg-white text-ocean hover:bg-seafoam hover:text-ocean">
              <a href="#latest-wire">{copy.readLatest}</a>
            </Button>
            <Button asChild variant="outline" className="border-white/40 text-white hover:bg-white hover:text-ocean">
              <a href="#wire-guide">{copy.howToUse}</a>
            </Button>
          </div>
        </div>

        <div className="rounded-[1.5rem] border border-white/15 bg-white/10 p-5 backdrop-blur-xl">
          <p className="text-sm font-black uppercase tracking-[0.18em] text-seafoam">{copy.findBriefing}</p>
          <div className="relative mt-4">
            <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ocean" />
            <Input
              value={searchQuery}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder={copy.searchPlaceholder}
              aria-label={copy.searchLabel}
              className="border-white/30 bg-white pl-11 text-ocean placeholder:text-storm"
            />
          </div>
          <div className="mt-5 grid gap-3 sm:grid-cols-3">
            {quickLinks.map(({ label, href, icon: Icon }) => (
              <Link key={label} to={`/${lang}${href}`} className="rounded-2xl border border-white/15 bg-white/10 p-4 text-sm font-black text-white transition hover:bg-white hover:text-ocean">
                <Icon className="mb-3 h-5 w-5" /> {label}
              </Link>
            ))}
          </div>
          <div className="mt-5 rounded-2xl bg-white/10 p-4 text-sm leading-6 text-white/82">
            <strong className="text-white">{copy.whatIsTitle}</strong> {copy.whatIsText}
          </div>
          <p className="mt-4 text-sm font-bold text-seafoam">{articleCount} {copy.availableSuffix}</p>
        </div>
      </div>
    </section>
  );
}